export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9092.3ba9f1ca.jpg";